<table #table class="jit-table">
  <thead>
    <tr>
      <ng-content select="[header]"></ng-content>
    </tr>
  </thead>
  <tbody>
    <ng-content select="[body]"></ng-content>
  </tbody>
</table>